import { render, staticRenderFns } from "./MyMask.vue?vue&type=template&id=022edd98&scoped=true&"
import script from "./MyMask.vue?vue&type=script&lang=js&"
export * from "./MyMask.vue?vue&type=script&lang=js&"
import style0 from "./MyMask.vue?vue&type=style&index=0&id=022edd98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022edd98",
  null
  
)

export default component.exports